import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-32 bg-primary/5">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="mx-auto max-w-3xl text-center space-y-8">
          <div className="inline-flex items-center justify-center p-2 bg-primary/10 rounded-full">
            <Sparkles className="h-8 w-8 text-primary" />
          </div>
          
          <h2 className="text-3xl md:text-5xl font-bold">
            Pronto para turbinar suas métricas?
          </h2>
          
          <p className="text-xl text-muted-foreground">
            Comece seu teste grátis de 14 dias agora
            <br />
            <span className="text-sm">Não é necessário cartão de crédito</span>
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Button
              size="lg"
              onClick={() => navigate('/auth?signup=true')}
              className="gap-2"
            >
              Começar Teste Grátis
              <ArrowRight className="h-4 w-4" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => navigate('/auth')}
            >
              Já tenho uma conta
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
